export default __webpack_public_path__ + "static/media/consol-1-en.24afc393.svg";